import PageHeader from "@/components/base/PageHeader";
import { Link } from "react-router-dom";
import { navLinks, siteName } from "@/mocks/site";

const offerings = [
  { icon: "ri-film-line", title: "剧集剧情介绍", desc: "按篇章整理剧集列表，提供剧情简介与出场角色，方便定位与回顾。" },
  { icon: "ri-user-star-line", title: "角色资料分析", desc: "收录主角、反派与次要角色资料，涵盖背景、能力与关系解析。" },
  { icon: "ri-newspaper-line", title: "动漫资讯整理", desc: "汇集官方动态、周边情报、粉丝活动与剧情解析等资讯内容。" },
  { icon: "ri-compass-3-line", title: "系列导航指引", desc: "提供剧集与篇章的浏览导航，帮助新老观众快速找到想看的内容。" },
];

const contacts = [
  { icon: "ri-mail-line", label: "联系邮箱", value: "contact@naruto-channel.demo" },
  { icon: "ri-wechat-line", label: "微信公众号", value: "火影忍者动漫频道" },
  { icon: "ri-weibo-line", label: "微博", value: "@火影忍者动漫频道" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩", value: "火影忍者动漫频道" },
];

export default function About() {
  return (
    <div>
      <PageHeader
        eyebrow="关于我们"
        icon="ri-information-line"
        title={`关于${siteName}`}
        description="了解本站的定位、内容范围与联系方式，以及我们在版权与免责方面的说明。"
      />

      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.5fr_1fr]">
          <div className="space-y-10">
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950">网站定位</h2>
              <p className="mt-3 text-sm leading-loose text-foreground-700 md:text-base">
                {siteName}是一个面向火影忍者爱好者、动漫迷及二次元用户的动漫专题资料站。
                我们的目标是把零散的动漫信息整理成系统、清晰、便于查阅的内容，
                让每一位读者都能更轻松地走进忍者世界。
              </p>
              <p className="mt-3 text-sm leading-loose text-foreground-700 md:text-base">
                与追求资讯速度的媒体不同，本站更注重内容的完整性与准确性，
                力求做到「查得到、看得懂、留得住」。所有内容均为资料展示用途，
                不提供在线观看、下载或任何形式的付费服务。
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950">我们提供什么</h2>
              <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {offerings.map((item) => (
                  <div
                    key={item.title}
                    className="rounded-lg border border-background-200 bg-background-50 p-5"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${item.icon} text-lg`} />
                    </span>
                    <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950">快速导航</h2>
              <div className="mt-4 flex flex-wrap gap-3">
                {navLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </section>
          </div>

          <aside className="space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">联系方式</h2>
              <p className="mt-2 text-sm text-foreground-600">
                以下联系方式仅作演示展示，如有内容建议欢迎通过邮箱与我们交流。
              </p>
              <ul className="mt-5 space-y-4">
                {contacts.map((contact) => (
                  <li key={contact.label} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                      <i className={contact.icon} />
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{contact.label}</p>
                      <p className="text-sm font-medium text-foreground-900">{contact.value}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-shield-check-line text-primary-600" />
                版权与免责声明
              </h2>
              <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" />
                  <span>本站为非商业性质的动漫资料展示平台，内容仅供参考与交流。</span>
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" />
                  <span>站内示例内容均为原创或基于公开信息整理，如涉及版权问题请联系我们处理。</span>
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" />
                  <span>本站不提供任何在线观看、下载、付费及用户登录功能。</span>
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" />
                  <span>文章观点仅代表整理者理解，不代表原作品官方立场。</span>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}